module.exports = __webpack_public_path__ + "static/media/hand-heart.e23a26f4.svg";